import { Component, OnDestroy, OnInit, ViewChild, ElementRef, Input } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import {ActivatedRoute, Router} from '@angular/router';
import {PaginationInstance} from "ngx-pagination";
import {UserVerificationService} from "../services/user-verification.service";
import {KeycloakService} from "../services/keycloak.service";
import {HttpService} from "../services/http.service";
import {DateUtils} from "../services/date-utils";
import {flatMap, map, tap} from 'rxjs/operators';

declare var $: any;

@Component({ standalone: false, 
  selector: 'app-message-logs',
  templateUrl: './message-logs.component.html',
})
export class MessageLogsComponent implements OnInit, OnDestroy {

  isAdmin: boolean = false;
  username: string = KeycloakService.username;
  listLogs: any[];
  pLogs: number = 1;
  totalPageNumber: number;
  pageSize: number;

  public inputKeywordLogsSearch = "";
  public optionLogsSearch = "Search Type";

  public messageLogsRefreshing = false;

  @Input() virtId: string;
  @Input() netIds: string[];
  @Input() getLogsUrl: string;
  @Input() useNetIdsForSearch: boolean = false;

  @ViewChild('pagerLogsNetworkServer', { static: true }) paginationLogsChild;
  constructor(private route: ActivatedRoute,
    private router: Router,
    private http: HttpClient,
    private userVerificationService: UserVerificationService,
    private httpService: HttpService) {

      this.isAdmin = this.userVerificationService.isAdmin;
  }

  //get Logs widget
  Logs(id, startTime, endTime) {
    var url = this.getLogsUrl;
    this.messageLogsRefreshing = true;
    var body: any;
    if(this.useNetIdsForSearch) {
      body = {"netIds": id, "pageNumber": 1, "username": KeycloakService.username, "startTime": startTime, "endTime": endTime};
    } else {
      body = {"virtId": id, "pageNumber": 1, "username": KeycloakService.username, "startTime": startTime, "endTime": endTime};
    }
    const headers = new HttpHeaders({'Content-Type': 'application/json'});
    let options =  {headers: headers};
    this.http.post<any>(url, body, options).subscribe(
        data => {
          this.listLogs = data["messageLogs"], this.totalPageNumber = data["pageCount"], this.pageSize = data["pageSize"];
          this.messageLogsRefreshing = false;
        }
      );
  }

  LogsNsGroup(netIds, startTime, endTime) {
    var url = this.getLogsUrl;
    this.messageLogsRefreshing = true;
    let body = {"netIds": netIds, "pageNumber": 1, "username": KeycloakService.username, "startTime": startTime.toString(), "endTime": endTime.toString()};
    const headers = new HttpHeaders({'Content-Type': 'application/json'});
    let options =  {headers: headers};
    this.http.post<any>(url, body, options).subscribe(
      data => {
        this.listLogs = data["messageLogs"], this.totalPageNumber = data["pageCount"], this.pageSize = data["pageSize"];
        this.messageLogsRefreshing = false;
      }
    );
  }

  //get Logs when pager is clicked
  LogsClicked(getId, pNumber) {
    let startTime = Number(Date.parse($('.datepicker1').val()));
    let endTime = Number(Date.parse($('.datepicker2').val()));
    var url = this.getLogsUrl;
    this.messageLogsRefreshing = true;
    var body: any;
    if(this.useNetIdsForSearch) {
      body = {"netIds": getId, "pageNumber": pNumber, "username": KeycloakService.username, "startTime": startTime.toString(), "endTime": endTime.toString()};
    } else {
      body = {"virtId": getId, "pageNumber": pNumber, "username": KeycloakService.username, "startTime": startTime.toString(), "endTime": endTime.toString()};
    }
    const headers = new HttpHeaders({'Content-Type': 'application/json'});
    let options =  {headers: headers};
    this.http.post<any>(url, body, options).subscribe(
        data => {
          this.listLogs = data["messageLogs"], this.totalPageNumber = data["pageCount"], this.pageSize = data["pageSize"];
          this.messageLogsRefreshing = false;
        }
      );
  }

  updateLogsPagination(pageNumber) {
    let date1 = Number(Date.parse($('.datepicker1').val()));
    let date2 = Number(Date.parse($('.datepicker2').val()));
    switch (this.optionLogsSearch) {
      case 'Search Type':
        if(this.useNetIdsForSearch) {
          this.LogsClicked(this.netIds, pageNumber)
        } else {
          this.LogsClicked(this.virtId, pageNumber);
        }
        break;
      case 'Message Type':
      case 'Sender ID':
      case 'Receiver ID':
      case 'Transaction ID':
      case 'NetID':
      case 'NSID':
      case 'End-device identifier':
      case 'Device address':
        if (this.inputKeywordLogsSearch != '') {
          if(this.useNetIdsForSearch) {
            this.LogsSearch(date1, date2, this.netIds, this.getLogsUrl, this.optionLogsSearch, this.inputKeywordLogsSearch, pageNumber);
          } else {
            this.LogsSearch(date1, date2, this.virtId, this.getLogsUrl, this.optionLogsSearch, this.inputKeywordLogsSearch, pageNumber);
          }
        } else {
          if(this.useNetIdsForSearch) {
            this.LogsClicked(this.netIds, pageNumber)
          } else {
            this.LogsClicked(this.virtId, pageNumber);
          }
        }
        break;
      default:
        break;
    }
  }

  //Logs search func
  LogsSearch(startTime, endTime, vIdSearch, urlSearch, filterSearch, keywordSearch, pNumber) {
    if (filterSearch == "Message Type") {
      var body: any;
      if(this.useNetIdsForSearch) {
        body = {"netIds": vIdSearch, "messageType": keywordSearch, "pageNumber": pNumber, "username": KeycloakService.username, "startTime": startTime.toString(), "endTime": endTime.toString()};
      } else {
        body = {"virtId": vIdSearch, "messageType": keywordSearch, "pageNumber": pNumber, "username": KeycloakService.username, "startTime": startTime.toString(), "endTime": endTime.toString()};
      }
      var url = urlSearch;
      this.messageLogsRefreshing = true;
      const headers = new HttpHeaders({'Content-Type': 'application/json'});
      let options =  {headers: headers};
      this.http.post<any>(url, body, options).subscribe(
          data => {
            this.listLogs = data["messageLogs"], this.totalPageNumber = data["pageCount"], this.pageSize = data["pageSize"];
            this.messageLogsRefreshing = false;
          }
        );
    }
    if (filterSearch == "Sender ID") {
      var body: any;
      if(this.useNetIdsForSearch) {
        body = {"netIds": vIdSearch, "senderId": keywordSearch, "pageNumber": pNumber, "username": KeycloakService.username, "startTime": startTime.toString(), "endTime": endTime.toString()};
      } else {
        body = {"virtId": vIdSearch, "senderId": keywordSearch, "pageNumber": pNumber, "username": KeycloakService.username, "startTime": startTime.toString(), "endTime": endTime.toString()};
      }
      var url = urlSearch;
      this.messageLogsRefreshing = true;
      const headers = new HttpHeaders({'Content-Type': 'application/json'});
      let options =  {headers: headers};
      this.http.post<any>(url, body, options).subscribe(
          data => {
            this.listLogs = data["messageLogs"], this.totalPageNumber = data["pageCount"], this.pageSize = data["pageSize"];
            this.messageLogsRefreshing = false;
          }
        );
    }
    if (filterSearch == "NetID") {
      var body: any;
      if(this.useNetIdsForSearch) {
        body = {"netIds": vIdSearch, "netId": keywordSearch, "pageNumber": pNumber, "username": KeycloakService.username, "startTime": startTime.toString(), "endTime": endTime.toString()};
      } else {
        body = {"virtId": vIdSearch, "netId": keywordSearch, "pageNumber": pNumber, "username": KeycloakService.username, "startTime": startTime.toString(), "endTime": endTime.toString()};
      }
      var url = urlSearch;
      const headers = new HttpHeaders({'Content-Type': 'application/json'});
      let options =  {headers: headers};
      this.http.post<any>(url, body, options).subscribe(
          data => {
            this.listLogs = data["messageLogs"], this.totalPageNumber = data["pageCount"], this.pageSize = data["pageSize"]
          }
        );
    }
    if (filterSearch == "NSID") {
      var body: any;
      if(this.useNetIdsForSearch) {
        body = {"netIds": vIdSearch, "nsId": keywordSearch, "pageNumber": pNumber, "username": KeycloakService.username, "startTime": startTime.toString(), "endTime": endTime.toString()};
      } else {
        body = {"virtId": vIdSearch, "nsId": keywordSearch, "pageNumber": pNumber, "username": KeycloakService.username, "startTime": startTime.toString(), "endTime": endTime.toString()};
      }
      var url = urlSearch;
      const headers = new HttpHeaders({'Content-Type': 'application/json'});
      let options =  {headers: headers};
      this.http.post<any>(url, body, options).subscribe(
          data => {
            this.listLogs = data["messageLogs"], this.totalPageNumber = data["pageCount"], this.pageSize = data["pageSize"]
          }
        );
    }
    if (filterSearch == "Receiver ID") {
      var body: any;
      if(this.useNetIdsForSearch) {
        body = {"netIds": vIdSearch, "receiverId": keywordSearch, "pageNumber": pNumber, "username": KeycloakService.username, "startTime": startTime.toString(), "endTime": endTime.toString()};
      } else {
        body = {"virtId": vIdSearch, "receiverId": keywordSearch, "pageNumber": pNumber, "username": KeycloakService.username, "startTime": startTime.toString(), "endTime": endTime.toString()};
      }
      var url = urlSearch;
      this.messageLogsRefreshing = true;
      const headers = new HttpHeaders({'Content-Type': 'application/json'});
      let options =  {headers: headers};
      this.http.post<any>(url, body, options).subscribe(
          data => {
            this.listLogs = data["messageLogs"], this.totalPageNumber = data["pageCount"], this.pageSize = data["pageSize"];
            this.messageLogsRefreshing = false;
          }
      );
    }
    if (filterSearch == "Transaction ID") {
      var body: any;
      if(this.useNetIdsForSearch) {
        body = {"netIds": vIdSearch, "transactionId": keywordSearch, "pageNumber": pNumber, "username": KeycloakService.username, "startTime": startTime.toString(), "endTime": endTime.toString()};
      } else {
        body = {"virtId": vIdSearch, "transactionId": keywordSearch, "pageNumber": pNumber, "username": KeycloakService.username, "startTime": startTime.toString(), "endTime": endTime.toString()};
      }
      var url = urlSearch;
      this.messageLogsRefreshing = true;
      const headers = new HttpHeaders({'Content-Type': 'application/json'});
      let options =  {headers: headers};
      this.http.post<any>(url, body, options).subscribe(
          data => {
            this.listLogs = data["messageLogs"], this.totalPageNumber = data["pageCount"], this.pageSize = data["pageSize"];
            this.messageLogsRefreshing = false;
          }
      );
    }
    if (filterSearch == "End-device identifier") {
      var body: any;
      if(this.useNetIdsForSearch) {
        body = {"netIds": vIdSearch, "devEui": keywordSearch, "pageNumber": pNumber, "username": KeycloakService.username, "startTime": startTime.toString(), "endTime": endTime.toString()};
      } else {
        body = {"virtId": vIdSearch, "devEui": keywordSearch, "pageNumber": pNumber, "username": KeycloakService.username, "startTime": startTime.toString(), "endTime": endTime.toString()};
      }
      var url = urlSearch;
      this.messageLogsRefreshing = true;
      const headers = new HttpHeaders({'Content-Type': 'application/json'});
      let options =  {headers: headers};
      this.http.post<any>(url, body, options).subscribe(
          data => {
            this.listLogs = data["messageLogs"], this.totalPageNumber = data["pageCount"], this.pageSize = data["pageSize"];
            this.messageLogsRefreshing = false;
          }
        );
    }
    if (filterSearch == "Device address") {
      var body: any;
      if(this.useNetIdsForSearch) {
        body = {"netIds": vIdSearch, "devAddr": keywordSearch, "pageNumber": pNumber, "username": KeycloakService.username, "startTime": startTime.toString(), "endTime": endTime.toString()};
      } else {
        body = {"virtId": vIdSearch, "devAddr": keywordSearch, "pageNumber": pNumber, "username": KeycloakService.username, "startTime": startTime.toString(), "endTime": endTime.toString()};
      }
      var url = urlSearch;
      this.messageLogsRefreshing = true;
      const headers = new HttpHeaders({'Content-Type': 'application/json'});
      let options =  {headers: headers};
      this.http.post<any>(url, body, options).subscribe(
          data => {
            this.listLogs = data["messageLogs"], this.totalPageNumber = data["pageCount"], this.pageSize = data["pageSize"];
            this.messageLogsRefreshing = false;
          }
        );
    }
    if (filterSearch == 'Search Type') {
      if(this.useNetIdsForSearch) {
        this.Logs(this.netIds, startTime.toString(), endTime.toString())
      } else {
        this.Logs(this.virtId, startTime.toString(), endTime.toString())
      }
    }
  }

  refreshLogs() {
    this.paginationLogsChild.pageOne()
  }

  showDatePicker1() {
    $('.datepicker1').datepicker('show');
  }

  showDatePicker2() {
    $('.datepicker2').datepicker('show');
    $('.datepicker2').datepicker('setStartDate', $('.datepicker1').val());
  }

  ngOnInit() {
    var end = DateUtils.addDays(new Date(), 1);
    var start = DateUtils.subtractDays(end, 3);
    $('.datepicker1').datepicker('setDate', this.formatDate(start));
    $('.datepicker2').datepicker('setDate', this.formatDate(end));

    if(this.useNetIdsForSearch) this.Logs(this.netIds, start.getTime().toString(), end.getTime().toString());
    else this.Logs(this.virtId, start.getTime().toString(), end.getTime().toString());

    $('.table-filter-search').selectpicker({
      liveSearch: true,
      maxOptions: 1,
      container: 'body'
    });

    // Ensure default selection is visible in the bootstrap-select UI
    $('.table-filter-search').selectpicker('val', this.optionLogsSearch);

    $(document).on("change", ".datepicker2", function () {
      if ($('.datepicker1').val() == "") {
        $('.datepicker1').datepicker('setDate', $('.datepicker2').val());
      }
    });

    $(document).on("change", ".datepicker1", function () {
      if ($('.datepicker1').val() > $('.datepicker2').val() && $('.datepicker2').val() != "") {
        $('.datepicker2').datepicker('setDate', $('.datepicker1').val());
      }
    });
  }

  onKeywordSearch(event: KeyboardEvent) {
    if (event.keyCode === 13) {
      this.paginationLogsChild.pageOne()
    }
  }

  onOptionLogsSearchChanged(event) {
    /**
    const value = event.target.value;
    if (value == "Time") {
      $(".input-group.date").show();
      $(".form-control.logs").hide();
      $(".fa-search.logs").hide();
    } else {
      $(".input-group.date").hide();
      $(".form-control.logs").show();
      $(".fa-search.logs").show();
    }
    **/
    this.inputKeywordLogsSearch = "";
  }

  ngOnDestroy() {

  }

  formatDate(date) {
    var dd = String(date.getDate()).padStart(2, '0');
    var mm = String(date.getMonth() + 1).padStart(2, '0'); //January is 0!
    var yyyy = date.getFullYear();
    return  mm + '.' + dd + '.' + yyyy;
  }

}
